@if (isLoading) {
<div class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>
} @else if (order) {
<div class="order-info-container">
    <div class="top-container">
        <div class="left-section">
            <div class="icon-container" (click)="goBack()">
                <mat-icon svgIcon="arrowleft" class="back-icon"></mat-icon>
            </div>

            <div class="title-container">
                <p class="title font-poppins">Order Items</p>
                <p class="subtitle">Here you can view all items included in this order.</p>
            </div>
        </div>

        <div class="right-section">
            <p class="orderid-label">Order ID</p>
            <p class="order-id font-poppins">#{{ order.id }}</p>
        </div>
    </div>

    <div class="bottom-container">
        <div class="left-section">
            <div class="item-container">
                @for (item of order.orderItems; let i = $index; track i) {
                <div class="item-section">
                    <div class="image-container" [class]="'product-image-gradient' + ((i % 3) + 1)">
                        <img class="item-image" [src]="item.product?.images?.imagesUrl?.[0]" />
                    </div>

                    <div class="item-details">
                        <p class="name-track-container">
                            <span class="product-name font-poppins" appEllipsis maxWidth="220px">{{
                                item.product?.name
                            }}</span>
                            <span class="track" (click)="navigateOrderPage(order.id, item.productId)"
                                >Track Order
                                <mat-icon svgIcon="rightarrow" class="arrow-icon"></mat-icon>
                            </span>
                        </p>

                        @if (!item.product?.category?.includes(categories.BuyBlocks)) {
                        <p class="description">
                            <span>Color: MultiColor</span>
                            <span class="block">{{ item.product?.modelQuantityJson?.totalBlock }} Blocks</span>
                        </p>
                        } @else {
                        <div
                            class="block-item-info-container"
                            *ngIf="item.product?.category?.includes(categories.BuyBlocks)"
                        >
                            <div class="node-hole-plane-config">
                                <div *ngIf="getFacesByType(item, 'Plane').length > 0" class="plane-config">
                                    <span class="block-face-label">{{ "cart.shapeFacetype.plane" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(item, "Plane").join(", ") }}</span>
                                </div>

                                <div *ngIf="getFacesByType(item, 'Hole').length > 0" class="hole-config">
                                    <span class="block-face-label">{{ "cart.shapeFacetype.hole" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(item, "Hole").join(", ") }}</span>
                                </div>

                                <div *ngIf="getFacesByType(item, 'Node').length > 0" class="node-config">
                                    <span class="block-face-label">{{ "cart.shapeFacetype.node" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(item, "Node").join(", ") }}</span>
                                </div>
                            </div>

                            <div class="color-config">
                                <div class="color-title-section">
                                    <mat-icon [svgIcon]="'color'" class="color-icon"></mat-icon>
                                    <p class="color-title">Custom Color configuration</p>
                                </div>

                                <div class="color-info">
                                    <div *ngFor="let color of getFaceColors(item.singleBlockInfoDirectBuy?.color)">
                                        <div class="color-item">
                                            <div class="color-name">
                                                <span
                                                    class="color-box"
                                                    [ngStyle]="{
                                                        'background-color': getColorValue(color.value)
                                                    }"
                                                ></span>
                                                <span class="block-face-label">{{ color.key }} </span>
                                            </div>
                                            <div class="block-face-value">
                                                {{ color.value }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }

                        <div class="quantity-price-container">
                            <p class="quantity-container">
                                <span class="label">Qunatity</span>
                                <span class="value">{{ item.quantity }}x</span>
                            </p>
                            <p class="price-container">
                                <span class="label">Price</span>
                                <span class="price-info font-poppins">
                                    @if (item.discountedPrice) {
                                    <span class="price">
                                        {{ item.discountedPrice | currency: "INR" }}
                                    </span>
                                    <span class="original-price">
                                        {{ item.price | currency: "INR" }}
                                    </span>
                                    } @else {
                                    <span class="price">
                                        {{ item.price | currency: "INR" }}
                                    </span>
                                    }
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>

        <div class="right-section">
            <div class="delivery-location">
                <p class="heading font-poppins">
                    <span class="icon-container">
                        <mat-icon svgIcon="location"></mat-icon>
                    </span>
                    Delivery Address
                </p>

                <p class="name font-poppins">
                    {{ order.orderAddress?.shippingAddress?.name }}
                </p>
                <p class="address">
                    {{ order.orderAddress?.shippingAddress?.address }}
                </p>
                <p class="state">
                    {{ order.orderAddress?.shippingAddress?.city }}, {{ order.orderAddress?.shippingAddress?.state }},
                    {{ order.orderAddress?.shippingAddress?.pincode }}
                </p>
                <p class="phone">
                    <mat-icon svgIcon="phone" class="phone-icon"></mat-icon>
                    {{ order.orderAddress?.shippingAddress?.mobileNumber }}
                </p>
            </div>

            <div class="payment-container">
                <p class="heading font-poppins">Payment & Rewards</p>

                <p class="section">
                    <span class="label">Payment Method:</span>
                    <span class="value payment-method">{{ order.paymentMethod }}</span>
                </p>

                <p class="section">
                    <span class="label">Payment Status:</span>
                    <span class="value payment-status">{{ order.paymentStatus }}</span>
                </p>
            </div>

            <div class="order-summary">
                <p class="heading font-poppins">Order Summary</p>

                <p class="section">
                    <span class="label">Subtotal ({{ order.orderItems?.length }})</span>
                    <span class="value subtotal">{{ order.currentSubTotal | currency: "INR" }}</span>
                </p>

                <p class="section">
                    <span class="label">Discount</span>
                    <span class="value discount">-{{ order.currentCouponDiscount | currency: "INR" }}</span>
                </p>

                <p class="section">
                    <span class="label">Delivery Charges</span>
                    <span class="value delivery">FREE</span>
                </p>

                @if (order.originalCoinsUsed) {
                <p class="section">
                    <span class="label">Coins Used</span>
                    <span class="value coin">{{ order.originalCoinsUsed | currency: "INR" }}</span>
                </p>
                }

                <div class="separator"></div>

                <p class="section">
                    <span class="label total-label">Total Amount</span>
                    <span class="value total">{{ order.currentTotal | currency: "INR" }}</span>
                </p>
            </div>

            <button
                mat-flat-button
                class="track-order-btn btn-white"
                [disabled]="!isReturnable(order)"
                (click)="navigateItemList('return')"
            >
                <mat-icon>keyboard_return</mat-icon>
                Return
            </button>

            <button
                mat-flat-button
                class="track-order-btn btn-white"
                [disabled]="!isExchangeable(order)"
                (click)="navigateItemList('exchange')"
            >
                <mat-icon>swap_horiz</mat-icon>
                Exchange
            </button>

            <button mat-flat-button class="track-order-btn btn-white">
                <mat-icon>download</mat-icon>
                Download Invoice
            </button>

            <button mat-flat-button class="track-order-btn btn-white">
                <mat-icon>support_agent</mat-icon>
                Need Help
            </button>
        </div>
    </div>
</div>
} @else {
<div class="no-order-container">
    <app-no-order-item></app-no-order-item>
</div>
}
